import { Country } from '~/Api/Country';
import { ApiClientError } from '~/ApiClient';

import { Error, ErrorCode } from './Error';

export const mapError = (error: ApiClientError): Error => {
	const errorCode = error.code as ErrorCode;
	const { duplicateCountries, missingSettings, product } = (error.meta ?? {}) as {
		duplicateCountries?: { alpha2: string; name: string }[];
		missingSettings?: string[];
		product?: { id: string };
	};

	return new Error(
		errorCode,
		product?.id ?? null,
		new Set(missingSettings ?? []),
		duplicateCountries?.map((country) => new Country(country.alpha2, country.name)) ?? []
	);
};
